
<div [ngClass]="classCalc()" *ngIf="showFc" #wrapper>
  <ng-container *ngIf="!isSpacer">
    <ng-container *ngIf="children.length">
      <div *ngFor="let child of children" [ngClass]="{'row':true, 'vcenter':(labelColSize < 12) ? true : false }" style="margin-left:0px;margin-right:0px;">
        <div [ngClass]="firstColSizeCalc()">
          <b [ngClass]="isRequired()">{{child.name}}:</b>
        </div>
        <div [ngClass]="secondColSizeCalc()">
          <ng-container *ngTemplateOutlet="templateO"></ng-container>
          <ng-container *ngIf="!isEditable()">
            <div *ngIf="isCheckbox(child)" class="vcenter" [ngStyle]="{'height.px':aimsForm.maxChildHeight()}">
                <mat-checkbox [checked]="child.value" disabled> </mat-checkbox>
            </div>
            <div *ngIf="isQuillEditor(child)">
              <quill-editor class="fullWidth" [ngModel]="child.value" [readOnly]="true" [modules]="{toolbar:[]}" [style]="{height:'400px'}"></quill-editor>
            </div>
            <div class="secondColNotEditable linkBlock" *ngIf="isAimsLookup(child)" >
              <ng-container *ngIf="child.valueAccessor.linkHref != undefined">
                <a href="{{child.valueAccessor.linkHref}}" style="height: 32px;">{{displayValue(child)}}</a>
              </ng-container>
              <ng-container *ngIf="child.valueAccessor.linkHref == undefined">
                {{displayValue(child)}}
              </ng-container>
            </div>
            <div *ngIf="!isCheckbox(child) && !isQuillEditor(child) && !isAimsLookup(child)" style="width: 100%;">
                <mat-form-field >
                    <input matInput readonly min="0" [value]="displayValue(child)" />
                </mat-form-field>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!children.length">
      <ng-container *ngTemplateOutlet="templateO"></ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="isSpacer">
    <div [ngStyle]="{'height.px':aimsForm.maxChildHeight()}">&nbsp;</div>
  </ng-container>

</div>

<ng-template #templateO>
  <ng-content *ngIf="isEditable() || !children.length"></ng-content>
</ng-template>
